export const PRECISE_GPS_OPTIONS = {
  enableHighAccuracy: true,
  timeout: 22000,
  maximumAge: 0,
};

export function coordsToLocation(coords) {
  return {
    lat: coords.latitude,
    lng: coords.longitude,
    accuracy_m: coords.accuracy ?? null,
    heading: Number.isFinite(coords.heading) ? coords.heading : null,
    speed_mps: Number.isFinite(coords.speed) ? coords.speed : null,
    altitude_m: Number.isFinite(coords.altitude) ? coords.altitude : null,
    captured_at: new Date().toISOString(),
  };
}

export function getPreciseLocation() {
  return new Promise((resolve, reject) => {
    if (!("geolocation" in navigator)) {
      reject(new Error("GPS non disponible sur cet appareil"));
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve(coordsToLocation(pos.coords)),
      (err) => reject(err),
      PRECISE_GPS_OPTIONS
    );
  });
}

export function watchPreciseLocation(onLocation, onError) {
  if (!("geolocation" in navigator)) {
    if (onError) onError(new Error("GPS non disponible sur cet appareil"));
    return null;
  }
  return navigator.geolocation.watchPosition(
    (pos) => onLocation(coordsToLocation(pos.coords)),
    onError,
    PRECISE_GPS_OPTIONS
  );
}
